<template>
  <div>
    <span>{{ title }}</span>
    <v-tooltip
      v-if="tooltip"
      top
    >
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
        >
          <v-icon
            small
            color="#718096"
            class="icon ml-1"
          >mdi-information-variant-circle-outline</v-icon>
        </span>
      </template>
      <span>{{ tooltip }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'TableHeaderWithTooltip',
  props: ['title', 'tooltip'],
};
</script>

<style scoped>
p {
  margin: 0;
}

.icon {
  cursor: pointer;
}
</style>
